// // import { Facebook, Instagram, Twitter } from 'lucide-react';

// // export default function Footer() {
// //   return (
// //     <footer className="bg-secondary-dark text-white py-8">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="grid md:grid-cols-3 gap-8">
// //           {/* Company Info */}
// //           <div>
// //             <h3 className="text-3xl font-heading font-bold text-accent-base mb-4">Capital Offset</h3>
// //             <p className="text-gray-300 mb-4">
// //               We provide high-quality printing services in Ahmedabad, specializing in brochure, book, box, and more. With years of expertise, we deliver professional solutions for businesses across various industries.
// //             </p>
// //             <p className="text-gray-300">
// //               <strong>Contact Us:</strong><br />
// //               1234 Printing Lane, Ahmedabad, Gujarat, India <br />
// //               Phone: +91 123 456 7890<br />
// //               Email: <a href="mailto:info@satyamscan.com" className="text-accent-light hover:text-white">info@satyamscan.com</a>
// //             </p>
// //           </div>

// //           {/* Quick Links */}
// //           <div>
// //             <h3 className="text-2xl font-bold text-accent-base mb-4">Quick Links</h3>
// //             <ul className="space-y-2 text-gray-300">
// //               <li>
// //                 <a href="/" className="hover:text-accent-light transition-colors duration-300">Home</a>
// //               </li>
// //               <li>
// //                 <a href="/about" className="hover:text-accent-light transition-colors duration-300">About Us</a>
// //               </li>
// //               <li>
// //                 <a href="/services" className="hover:text-accent-light transition-colors duration-300">Services</a>
// //               </li>
// //               <li>
// //                 <a href="/portfolio" className="hover:text-accent-light transition-colors duration-300">Portfolio</a>
// //               </li>
// //               <li>
// //                 <a href="/contact" className="hover:text-accent-light transition-colors duration-300">Contact</a>
// //               </li>
// //             </ul>
// //           </div>

// //           {/* Social Media Links */}
// //           <div>
// //             <h3 className="text-2xl font-bold text-accent-base mb-4">Follow Us</h3>
// //             <div className="flex space-x-6">
// //               <a href="https://www.facebook.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Facebook className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.instagram.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Instagram className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.twitter.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Twitter className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.linkedin.com/company/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Twitter className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="border-t border-gray-700 mt-8 pt-6">
// //           <div className="flex justify-between items-center">
// //             <p className="text-gray-300 text-sm">&copy; 2025 Capital Offset. All rights reserved.</p>
// //             <div className="text-sm text-gray-300">
// //               <a href="/privacy-policy" className="hover:text-accent-light transition-colors duration-300 mr-4">Privacy Policy</a>
// //               <a href="/terms-of-service" className="hover:text-accent-light transition-colors duration-300">Terms of Service</a>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // }

// import { Facebook, Instagram, Twitter } from 'lucide-react';
// import { Link } from 'react-router-dom';

// export default function Footer() {
//   return (
//     <footer className="bg-primary-dark text-white py-10">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Logo Section */}
//         <div className="flex items-center justify-center md:justify-start mb-8">
//           <Link href="/">
//             <a>
//               <img src="/logo.png" alt="Satyamscan" className="w-32" />
//             </a>
//           </Link>
//         </div>

//         {/* Footer Grid */}
//         <div className="grid md:grid-cols-3 gap-12">
//           {/* Company Info */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">About Satyamscan</h3>
//             <p className="text-gray-300 mb-4">
//               We provide premium quality printing services in Ahmedabad, specializing in a wide range of products such as brochures, books, and packaging. Our goal is to deliver exceptional results to our clients with precision and professionalism.
//             </p>
//             <p className="text-gray-300">
//               <strong>Contact Us:</strong><br />
//               1234 Printing Lane, Ahmedabad, Gujarat, India <br />
//               Phone: <a href="tel:+911234567890" className="text-accent-light hover:text-white">+91 123 456 7890</a><br />
//               Email: <a href="mailto:info@satyamscan.com" className="text-accent-light hover:text-white">info@satyamscan.com</a>
//             </p>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">Quick Links</h3>
//             <ul className="space-y-3 text-gray-300">
//               <li>
//                 <Link href="/">
//                   <a className="hover:text-accent-light transition-colors duration-300">Home</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/about">
//                   <a className="hover:text-accent-light transition-colors duration-300">About Us</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/services">
//                   <a className="hover:text-accent-light transition-colors duration-300">Services</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/portfolio">
//                   <a className="hover:text-accent-light transition-colors duration-300">Portfolio</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/contact">
//                   <a className="hover:text-accent-light transition-colors duration-300">Contact</a>
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* Social Media Links */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">Follow Us</h3>
//             <div className="flex space-x-6">
//               <a href="https://www.facebook.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//                 <Facebook className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.instagram.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//                 <Instagram className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.twitter.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//                 <Twitter className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.linkedin.com/company/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
//                 <Twitter className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* Legal Links */}
//         <div className="border-t border-gray-700 mt-12 pt-8">
//           <div className="flex justify-between items-center">
//             <p className="text-gray-300 text-sm">
//               &copy; 2025 Satyamscan. All rights reserved.
//             </p>
//             <div className="text-sm text-gray-300 space-x-4">
//               <Link href="/privacy-policy">
//                 <a className="hover:text-accent-light transition-colors duration-300">Privacy Policy</a>
//               </Link>
//               <Link href="/terms-of-service">
//                 <a className="hover:text-accent-light transition-colors duration-300">Terms of Service</a>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Code } from 'lucide-react';
import { Link } from 'react-router-dom'; // For routing links
import logo from '../assets/Untitled design (3).svg'
const Footer = () => {
  return (
    <footer className="bg-secondary-dark text-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1: Logo and Description */}
          <div>
          <div className="flex items-center space-x-1">
        <img 
          src={logo} 
          alt="Capital Offset Logo" 
          className="h-12 w-auto" // Adjust the size as needed
        />
        <span className="text-3xl font-heading font-bold text-accent-base">Capital Offset</span>
      </div>
            
            <p className="text-gray-400 mb-4">
            Capital Offset, a reputed name in the printing industry, We specialize in delivering premium communication materials for India's top companies. Our commitment to quality and precision sets us apart.
            </p>
            <div className=" mt-6 flex space-x-12">
              {/* Social Media Icons */}
          
              <a href="https://www.linkedin.com/company/capital-offset/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent-base">
                {/* LinkedIn SVG */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  className="h-6 w-6"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 20h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.508c0-1.313-.025-3.008-1.834-3.008-1.837 0-2.116 1.434-2.116 2.916v5.6h-3v-11h2.879v1.504h.041c.4-.757 1.379-1.555 2.837-1.555 3.033 0 3.594 1.995 3.594 4.59v6.461z" />
                </svg>
              </a>
             
            </div>
          </div>

          {/* Column 2: Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>
            <ul>
              <li className="flex items-center mb-2">
                <MapPin className="h-5 w-5 mr-2 text-gray-400" />
                <span className="text-gray-400">L801/1-2, GIDC, Sector 28, Gandhinagar, Gujarat 382028</span>
              </li>
              <li className="flex items-center mb-2">
                <Phone className="h-5 w-5 mr-2 text-gray-400" />
                <span className="text-gray-400">098250 38378</span>
              </li>
              <li className="flex items-center mb-2">
                <Mail className="h-5 w-5 mr-2 text-gray-400" />
                <span className="text-gray-400">capitaloffsetgujarat@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
            <ul>
              {/* <li className="mb-2">
                <Link to="/about" className="text-gray-400 hover:text-blue-600">About Us</Link>
              </li> */}
              <li className="mb-2">
                <Link to="/services" className="text-gray-400 hover:text-accent-base">Services</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-gray-400 hover:text-accent-base">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Services Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Our Services</h3>
            <ul>
           
    <li className="mb-2">
      <Link to="/services/pre-press" className="text-gray-400 hover:text-accent-base">Pre Press</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/digital-printing" className="text-gray-400 hover:text-accent-base">Digital Printing</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/offset-printing" className="text-gray-400 hover:text-accent-base">Offset Printing</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/post-press" className="text-gray-400 hover:text-accent-base">Post Press</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/packaging" className="text-gray-400 hover:text-accent-base">Packaging</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/card-printing" className="text-gray-400 hover:text-accent-base">Card Printing</Link>
    </li>
    {/* <li className="mb-2">
      <Link to="/services/brochure-printing" className="text-gray-400 hover:text-primary-base">Brochure Printing</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/catalog-printing" className="text-gray-400 hover:text-primary-base">Catalog Printing</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/book-printing" className="text-gray-400 hover:text-primary-base">Book Printing</Link>
    </li>
    <li className="mb-2">
      <Link to="/services/box-printing" className="text-gray-400 hover:text-primary-base">Box Printing</Link>
    </li> */}


            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center mt-12 border-t border-gray-700 pt-6">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Capital Offset. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
